import React from "react";
import { t } from "./CustomComponent.js";

// ปุ่มล้างตัวกรองมาตรฐานของหน้ารายงานทุกหน้า (ขอบเทา + ไอคอนหมุนย้อน + ข้อความ)
export default function ClearFilterButton({ onClick, className = "", ...rest }) {
  const label = t("mileage_clear_filters");
  return (
    <button
      type="button"
      className={`btn btn-white border px-3 py-2 rounded-3 text-nowrap d-inline-flex align-items-center gap-2 ${className}`.trim()}
      title={label}
      aria-label={label}
      onClick={onClick}
      {...rest}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 12a9 9 0 1 0 3-6.7" />
        <path d="M3 4v5h5" />
      </svg>
      <span>{label}</span>
    </button>
  );
}
